import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import _ from 'lodash';
import { TopicConfigDto } from '../../../../../../../types/rest/mockServiceTypes';
import BzDropdownButton, { DropdownButtonItem } from '../../../../../../../components/buttons/BzDropdownButton';

type ItemProps = {
  item: TopicConfigDto; // Adjust this type to match the shape of the items you're rendering
  onChange: (item: TopicConfigDto) => void;
  showLabel: boolean;
};

const TopicConfig = ({ item, onChange, showLabel }: ItemProps) => {
  const trueOption = {
    key: 'true',
    title: 'True',
  };

  const falseOption = {
    key: 'false',
    title: 'False',
  };
  const booleanDropdowns: DropdownButtonItem[] = [trueOption, falseOption];

  const getSelectedItem = () => {
    if (item.isDurable === true) {
      return trueOption;
    } else {
      return falseOption;
    }
  };

  const onSelect = (dropdownItem: DropdownButtonItem) => {
    const isDurable = dropdownItem.key.toLowerCase() === 'true';
    onChange({ ...item, isDurable: isDurable });
  };

  const updateSubscription = (fieldName: keyof TopicConfigDto, value: string) => {
    onChange({ ...item, [fieldName]: value });
  };

  const isDurable = !_.isNil(item?.isDurable) && item.isDurable === true;
  return (
    <Row>
      <Col md={isDurable ? 4 : 6}>
        {showLabel && <label>Topic Name</label>}
        <Form.Control value={item.name} onChange={e => updateSubscription('name', e.target.value)} />
      </Col>
      <Col md={isDurable ? 4 : 6}>
        {showLabel && <label>Is Durable</label>}
        <BzDropdownButton
          dropdownItems={booleanDropdowns}
          selectedItem={getSelectedItem()}
          onSelectedItem={onSelect}
          variant="secondary"
          id={'is-durable-' + item.name}
        />
      </Col>
      {isDurable && (
        <Col md={4}>
          {showLabel && <label>Durable Subscription Name</label>}
          <Form.Control
            onChange={e => updateSubscription('durableSubscriptionName', e.target.value)}
            value={!_.isNil(item?.durableSubscriptionName) ? item?.durableSubscriptionName : ''}
          />
        </Col>
      )}
    </Row>
  );
};

export default TopicConfig;
